module.exports = __webpack_public_path__ + "static/vista-10-08683e5e61b3609afa7a58bdf25ae815.png";